import Layout from '@/layout';
var contentRouter = {
  path: '/content',
  component: Layout,
  redirect: '/content/list',
  name: 'content',
  meta: {
    title: '内容',
    icon: 'content'
  },
  children: [{
    path: 'list',
    component: function component() {
      return import('@/views/content/list');
    },
    name: 'contentList',
    meta: {
      title: '内容管理',
      icon: 'content'
    }
    // redirect: '/content/list',
    // children: [
    //   {
    //     path: 'editArticle',
    //     component: () => import('@/views/content/edit/index'),
    //     name: 'editArticle',
    //     meta: { title: '添加医生', noCache: true, activeMenu: '/content/list' },
    //     hidden: true
    //   }
    // ]
  }, {
    path: 'editArticle',
    component: function component() {
      return import('@/views/content/edit/index');
    },
    name: 'editArticle',
    meta: {
      title: '文章内容',
      noCache: true,
      activeMenu: '/content/list'
    },
    hidden: true
  }]
};
export default contentRouter;